export const changeMakerHero = {
  title: 'How To Become A Change Maker',
  subtitle:
    'Become a part of our mission to inspire leadership, support communities, and drive positive social transformation.',
  cta: 'Become A Change Maker',
  ctaLink: '/contact',
}

export const joinMission = {
  title: 'Join Our Mission',
  text:
    'Become a part of Disha Foundation and help create positive change through youth empowerment, leadership, and community service. As a volunteer, you will contribute towards meaningful initiatives that inspire growth, responsibility, and nation-building.',
}

export const whyVolunteer = {
  title: 'Why Volunteer With Us?',
  items: [
    'Make a positive social impact',
    'Develop leadership and teamwork skills',
    'Participate in youth-focused initiatives',
    'Gain valuable experience and confidence',
    'Connect with passionate changemakers',
    'Contribute towards community and nation-building activities',
  ],
  titleMaxWidth: { md: 284, lg: 284 },
}

export const whoCanVolunteer = {
  title: 'Who Can Volunteer?',
  items: [
    'Students & Young Leaders',
    'Working Professionals',
    'Social Workers & Community Members',
    'Anyone passionate about service and positive change',
  ],
  titleMaxWidth: { md: 243, lg: 243 },
}

export const howToJoinSteps = [
  {
    step: '01',
    title: 'Fill Out The Registration Form',
    description:
      'Provide your basic details, interests, and areas where you would like to contribute.',
    stepBg: 'rgba(183, 7, 7, 0.12)',
    stepColor: '#b70707',
  },
  {
    step: '02',
    title: 'Attend Volunteer Orientation',
    description:
      "Learn about Disha Foundation's mission, activities, and volunteer opportunities.",
    stepBg: 'rgba(183, 142, 7, 0.12)',
    stepColor: '#b78e07',
  },
  {
    step: '03',
    title: 'Get Involved',
    description:
      'Participate in events, leadership programs, community drives, workshops, and social initiatives.',
    stepBg: 'rgba(7, 183, 183, 0.12)',
    stepColor: '#07b7b7',
  },
]
